export default __webpack_public_path__ + "static/media/Cubes.5f1a82c1.svg";